export default __webpack_public_path__ + "static/media/kabout.9f6edbb1.png";